import React from "react";
import "../src/assests/sass/Style.scss";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import Header from "./component/Header/Header";
import Home from "./component/Home/Home";
import store from "./redux/store";
import AboutUs from "./component/AboutUs/AboutUs";
import Footer from "./component/Footer/Footer";
import Package from "./component/Package/Package";
import ContactUs from "./component/ContactUs/ContactUs";
import FAQ from "./component/FAQ/FAQ";
import Feedback from "./component/Feedback/Feedback";
import PrivacyPolicy from "./component/PrivacyPolicy/PrivacyPolicy";
import TermUse from "./component/Term&Use/TermUse";
import { Helmet, HelmetProvider } from "react-helmet-async";

function App() {
  function CommonHeader() {
    return (
      <>
        {/* <Helmet>
          <title>
            Kior Healthcare – Trusted Diagnostic Centre in Punjab | Imaging &
            Pathology
          </title>
          <meta
            name="Title"
            content="Kior Healthcare is a leading diagnostic centre in Punjab offering accurate tests, a care pathology lab in Mohali, and advanced imaging center services."
          />
        </Helmet> */}

        <Header />
        <Outlet />
        <Footer />
      </>
    );
  }

  return (
    <HelmetProvider>
      <Provider store={store}>
        <Router>
          <Routes>
            <Route element={<CommonHeader />}>
              <Route path="/" element={<Home />} />
              <Route path="package" element={<Package />} />
              <Route path="contact-us" element={<ContactUs />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms-of-use" element={<TermUse />} />
            </Route>
          </Routes>
        </Router>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
